<template>
  <abstract-strategy :endpoints="endpoints" v-on:change="listChange" itemType="Allotment Rule">
    <template v-slot:default="{ value }">
      <allotment-rule-card
        v-for="(condition, index) in value.conditions"
        :key="'condition_' + index"
        :room_type_ids="value.room_type_ids"
        :condition="condition"
        v-on:delete="deleteItemTo(value, index)"
      ></allotment-rule-card>
      <md-button @click="addConditionTo(value)">Add condition</md-button>
    </template>
  </abstract-strategy>
</template>

<script>
import { SortAllotmentRuleDTO } from '@/openapi/src'
import Vue from 'vue'
import AllotmentRuleCard from '../../../components/AllotmentRules/AllotmentRuleCard.vue'
import { Allotment, AllotmentCondition } from '../../../components/AllotmentRules/models'
import Api from '../../../openapi/src/api/AllotmentRuleApi.js'
import AllotmentRuleDTO from '../../../openapi/src/model/AllotmentRuleDTO.js'
import AbstractStrategy from '../../Backend/Pages/AbstractStrategy/AbstractStrategyPage.vue'

const api = new Api()
export default {
  name: 'AllotmentRules',
  components: {
    AbstractStrategy,
    AllotmentRuleCard,
  },
  data() {
    return {
      endpoints: {
        list: api.fetchAllotmentRules.bind(api),
        get: api.fetchAllotmentRule.bind(api),
        create: (data) => (data ? AllotmentRuleDTO.constructFromObject(data) : new Allotment()),
        save: api.saveAllotmentRule.bind(api),
        update: api.updateAllotmentRule.bind(api),
        delete: api.deleteAllotmentRule.bind(api),
        duplicate: api.duplicateAllotmentRule.bind(api),
      },
    }
  },
  methods: {
    addConditionTo(value) {
      if (!value.conditions) Vue.set(value, 'conditions', [])

      value.conditions.push(new AllotmentCondition(false))
    },
    listChange(data) {
      if (data) {
        let list = new SortAllotmentRuleDTO()
        list.allotment_rule_ids = data.map((x) => x.id).filter((x) => x)
        api.sortAllotmentRules(this.$root.hotelId, list, (error, data) => {})
      }
    },
    deleteItemTo(value, index) {
      this.$delete(value.conditions, index)
    },
  },
}
</script>
